import { inject, Injectable, signal } from '@angular/core';
import { IBudget, IFormatedServiceBudget, IServicesFromBudget } from '@core/interface';
import { CurrencyOSRPipe } from '@core/pipes';
import { TranslateService } from '@ngx-translate/core';
import { CalcService } from './calc.service';

@Injectable({
  providedIn: 'root',
})
export class CalculateAdditionalServicesService {
  readonly #currencyPipe = inject(CurrencyOSRPipe);
  readonly #translateService = inject(TranslateService);
  readonly #calcService = inject(CalcService);

  // signals
  #budget = signal<IBudget>({});

  // TODO: quando identicarmos qual o serviço que vai ser utilizado, remover  o any e colocar o tipo correto
  generateServicesFromBudget(services: any[], selectedDate: Date, selectedHour: number): IServicesFromBudget {
    const price = signal(0);
    const applicableDiscount = signal(0);
    const total = signal(0);

    const items = services.map((service) => {
      const {
        serviceId,
        serviceName,
        servicePrice,
        promotionalStartDate,
        promotionalEndDate,
        promotionalStartHour,
        promotionalEndHour,
        promotionalPrice,
        costless,
        selected,
        isNeedComment,
      } = service;

      const isPromotional = this.#calcService.isPromotionActive(
        promotionalStartDate,
        promotionalEndDate,
        promotionalStartHour,
        promotionalEndHour,
        selectedDate,
        selectedHour
      );

      price.update((prev) => prev + servicePrice);
      applicableDiscount.update((prev) => prev + (isPromotional ? servicePrice - promotionalPrice : 0));
      total.set(price() - applicableDiscount());

      this.#budget.update(() => (
        {
          price: price(),
          applicableDiscount: applicableDiscount(),
          total: total(),
        }
      ));

      return {
        id: serviceId,
        serviceName: serviceName,
        price: servicePrice,
        finalPrice: this.#calcService.formatFinalPrice(servicePrice, costless, isPromotional, promotionalPrice),
        discount: isPromotional ? promotionalPrice : null,
        appliedDiscount: isPromotional ? this.#currencyPipe.transform(servicePrice - promotionalPrice, this.#translateService.currentLang) : null,
        isCostless: costless,
        isSelected: selected,
        isNeedComment: isNeedComment,
        isOnRequest: (servicePrice === 0) && !costless,
        isPromotional,
      } as IFormatedServiceBudget;
    });

    return {
      budget: this.#budget(),
      items,
    };
  }
}
